.modal {
  max-width: 400px;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: space-between;
}

.text {
  font-size: 14px;
}

.textInput {
  margin-top: 12px;
}
